import { io } from "socket.io-client";
global.io = io;
